import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectWarehouses, selectLoaded, selectLoading, selectTotal } from '../selectors/warehouses.selector';
import { warehousesActions } from '../actions/warehouses.actions';
import { GetWarehousesValue } from '../models';

@Service()
export class WarehousesFacade {
    private readonly store = inject(Store);

    readonly warehouses = this.store.selectSignal(selectWarehouses);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);

    getWarehouses(value: GetWarehousesValue): void {
        this.store.dispatch(warehousesActions.getWarehouses({ value }));
    }

    clear(): void {
        this.store.dispatch(warehousesActions.clear());
    }
}
